(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // The − / + on each slip change the number and send the form, no drawer needed.
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-step]');
      if (!button) return;
      const input = button.parentElement.querySelector('input[type="number"]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(button.dataset.step, 10));
      input.value = next;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function paint() {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(paint);
        ticking = true;
      }
    }, { passive: true });
    paint();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-reviews-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-reviews-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-reviews-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.dataset.auto === 'true' && !reduced;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }

    function paint() {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function schedule() {
      if (!auto) return;
      clearTimeout(timer);
      timer = setTimeout(function () { go(index + 1); schedule(); }, 6500);
    }

    root.querySelector('[data-reviews-prev]').addEventListener('click', function () { go(index - 1); schedule(); });
    root.querySelector('[data-reviews-next]').addEventListener('click', function () { go(index + 1); schedule(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.reviewsDot, 10)); schedule(); });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = i; }
        });
        index = nearest;
        paint();
      }, 80);
    });

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (e) { root.addEventListener(e, function () { clearTimeout(timer); }, { passive: true }); });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (e) { root.addEventListener(e, schedule, { passive: true }); });

    paint();
    schedule();
  });

  } catch(e) { console.error(e); }
})();
})();
